import { Decision } from "../models/decision";

export const WARNING_HEADER = "X-KMEX-RecipientWarning";

function headerValue(decision: Decision): string {
  return `v=1; level=${decision.level}; orgs=${decision.orgCount}`;
}

function callAsync<T>(
  invoke: (callback: (result: Office.AsyncResult<T>) => void) => void
): Promise<void> {
  return new Promise((resolve) => {
    invoke((result) => {
      // header set/remove failures must not block the send (FR-19: fail open)
      resolve();
      void result;
    });
  });
}

export async function setWarningHeader(item: Office.MessageCompose, decision: Decision): Promise<void> {
  await callAsync<void>((cb) => item.internetHeaders.setAsync({ [WARNING_HEADER]: headerValue(decision) }, cb));
}

export async function removeWarningHeader(item: Office.MessageCompose): Promise<void> {
  await callAsync<void>((cb) => item.internetHeaders.removeAsync([WARNING_HEADER], cb));
}
